import _ from "lodash";

export  const getFileData = (key: string, fileData: any): any => ({
    key: `${_.kebabCase(key)}${
        key.startsWith('additionalIncomeFiles') ? '' : 's'
    }`,
    data:  fileData,
    name: fileData?.name
})